module.exports = __webpack_public_path__ + "img/vette.51b7191a.jpg";